export type AudioState =
  | 'unloaded'
  | 'loading'
  | 'error'
  | 'paused'
  | 'seeking'
  | 'playing';

export const audioStates = [
  'unloaded',
  'loading',
  'error',
  'paused',
  'seeking',
  'playing',
] satisfies ReadonlyArray<AudioState>;

export type RequestedAudioState = '' | 'unloaded' | 'paused' | 'playing';

export type SleepTimer = '' | 'end-of-episode' | number;
